import { getCookie } from "@/src/utils/browser"
import { useEffect, useState } from "react"


const HOME_AI_SEARCH_COOKIE = 'homeAISearch'
const SRP_SMART_FILTER_SORT_COOKIE = 'srpSmartFilterSort'

export const useAIFeatureEnableManager = () => {
    const [aiFeatureEnabled, setAiFeatureEnabled] = useState({
        homeAISearch: false,
        srpSmartFilterSort: false
    })

    useEffect(() => {
        const homeAISearch = getCookie(HOME_AI_SEARCH_COOKIE)
        const srpSmartFilterSort = getCookie(SRP_SMART_FILTER_SORT_COOKIE)
        setAiFeatureEnabled({
            homeAISearch: homeAISearch == "true",
            srpSmartFilterSort: srpSmartFilterSort == 'true'
        })
    }, [])

    return aiFeatureEnabled
}
